import { z } from 'zod';
import { CursorQuery, Paginated } from '../../common/pagination.js';
import { BusinessListQuery, BusinessView, CreateReviewInput, EmployeeRow, ReviewSummary, ReviewView, UpsertBusinessInput, } from '../../business.js';
export const businessRoutes = {
    /** Owner: create or update the (single) business profile for this account. */
    upsertMine: {
        method: 'PUT',
        path: '/me/business',
        body: UpsertBusinessInput,
        response: BusinessView,
    },
    mine: { method: 'GET', path: '/me/business', response: BusinessView },
    get: { method: 'GET', path: '/businesses/:businessId', response: BusinessView },
    browse: {
        method: 'GET',
        path: '/businesses',
        query: BusinessListQuery,
        response: Paginated(BusinessView),
    },
    similar: {
        method: 'GET',
        path: '/businesses/:businessId/similar',
        query: CursorQuery,
        response: Paginated(BusinessView),
    },
    support: { method: 'POST', path: '/businesses/:businessId/support', response: BusinessView },
    unsupport: {
        method: 'DELETE',
        path: '/businesses/:businessId/support',
        response: BusinessView,
    },
    employees: {
        method: 'GET',
        path: '/businesses/:businessId/employees',
        query: CursorQuery,
        response: Paginated(EmployeeRow),
    },
    /** Owner adds/removes an employee (a member who has linked this company). */
    addEmployee: {
        method: 'POST',
        path: '/me/business/employees/:userId',
        response: z.object({ userId: z.string(), added: z.boolean() }),
    },
    removeEmployee: {
        method: 'DELETE',
        path: '/me/business/employees/:userId',
        response: z.object({ userId: z.string(), added: z.boolean() }),
    },
    reviews: {
        method: 'GET',
        path: '/businesses/:businessId/reviews',
        query: CursorQuery,
        response: Paginated(ReviewView),
    },
    reviewSummary: {
        method: 'GET',
        path: '/businesses/:businessId/reviews/summary',
        response: ReviewSummary,
    },
    /** One review per member per business; resubmit edits (AC-REV-01.2). */
    review: {
        method: 'PUT',
        path: '/businesses/:businessId/reviews/mine',
        body: CreateReviewInput,
        response: ReviewView,
    },
    deleteReview: {
        method: 'DELETE',
        path: '/businesses/:businessId/reviews/mine',
        response: z.object({ deleted: z.boolean() }),
    },
};
//# sourceMappingURL=routes.js.map